window.StringUtil = function() {}

/**
 * Camel case로 변경.(첫글자 소문자로 시작)
 *
 * @param input 입력 문자열
 * @return 변형된 문자열
 */
window.StringUtil.toCamelCase = function(input) {
  return input.replace(/-/g, '_').replace(/(_\w)/g, function(m) {
    return m[1].toUpperCase()
  })
}

window.String.prototype.toCamelCase = function() {
  return window.StringUtil.toCamelCase(this)
}

window._autoResizeTextArea = function(text) {
  text.style.height = 'auto'
  text.style.height = text.scrollHeight + 'px'
}

/**
 * Snake case로 변경.(첫글자 소문자로 시작)
 *
 * @param input 입력 문자열
 * @return 변형된 문자열
 */
window.StringUtil.toSnakeCase = function(input) {
  return input
    .replace(/\.?([A-Z]+)/g, function(x, y) {
      return '_' + y.toLowerCase()
    })
    .replace(/^_/, '')
}

window.String.prototype.toSnakeCase = function() {
  return window.StringUtil.toSnakeCase(this)
}

/**
 * Pascal case로 변경.(첫글자 대문자로 시작)
 *
 * @param input 입력 문자열
 * @return 변형된 문자열
 */
window.StringUtil.toPascalCase = function(input) {
  input = window.StringUtil.toCamelCase(input)
  return input.substring(0, 1).toUpperCase() + input.substring(1)
}

window.String.prototype.toPascalCase = function() {
  return window.StringUtil.toPascalCase(this)
}

window.String.prototype.replaceAll = function(searchStr, replaceStr) {
  return this.split(searchStr).join(replaceStr)
}

const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#x60;',
  '=': '&#x3D;'
}
window.String.prototype.escapeHtml = function() {
  return String(this).replace(/[&<>"'`=]/g, function(s) {
    return entityMap[s]
  })
}

window.String.prototype.stripTags = function() {
  const doc = new DOMParser().parseFromString(this, 'text/html')
  return doc.body.textContent || ''
}

window.String.prototype.getShortContents = function(len) {
  if (len > this.length) {
    return this
  }
  return this.substring(0, len) + '...'
}

window.String.prototype.string = function(len) {
  let s = ''
  let i = 0
  while (i++ < len) {
    s += this
  }
  return s
}

window.String.prototype.zf = function(len) {
  return '0'.string(len - this.length) + this
}

window.Number.prototype.zf = function(len) {
  return this.toString().zf(len)
}

window.Date.prototype.format = function(f) {
  if (!this.valueOf()) return ' '

  const weekKorName = [
    '일요일',
    '월요일',
    '화요일',
    '수요일',
    '목요일',
    '금요일',
    '토요일'
  ]

  const weekKorShortName = ['일', '월', '화', '수', '목', '금', '토']

  const weekEngName = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  const weekEngShortName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  const d = this

  return f.replace(/(yyyy|yy|MM|dd|KS|KL|ES|EL|HH|hh|mm|ss|a\/p)/gi, function(
    $1
  ) {
    switch ($1) {
      case 'yyyy':
        return d.getFullYear() // 년 (4자리)

      case 'yy':
        return (d.getFullYear() % 1000).zf(2) // 년 (2자리)

      case 'MM':
        const m = d.getMonth() + 1
        return m.zf(2) // 월 (2자리)

      case 'dd':
        return d.getDate().zf(2) // 일 (2자리)

      case 'KS':
        return weekKorShortName[d.getDay()] // 요일 (짧은 한글)

      case 'KL':
        return weekKorName[d.getDay()] // 요일 (긴 한글)

      case 'ES':
        return weekEngShortName[d.getDay()] // 요일 (짧은 영어)

      case 'EL':
        return weekEngName[d.getDay()] // 요일 (긴 영어)

      case 'HH':
        return d.getHours().zf(2) // 시간 (24시간 기준, 2자리)

      case 'hh':
        const h = d.getHours() % 12
        return h.zf(2) // 시간 (12시간 기준, 2자리)

      case 'mm':
        return d.getMinutes().zf(2) // 분 (2자리)

      case 'ss':
        return d.getSeconds().zf(2) // 초 (2자리)

      case 'a/p':
        return d.getHours() < 12 ? '오전' : '오후' // 오전/오후 구분

      default:
        return $1
    }
  })
}
